module.exports = __webpack_public_path__ + "img/caret-right-fill.9a55041c.svg";